import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { TestComponent } from './components/test/test.component';
import { PagesComponent } from './pages.component';
import { LayoutModule } from '../shared/layout/layout.module';
import { PagesRoutes } from './pages.routes';
import{ServiceModule} from './../services/service.module';
import { PageTabPanelComponent } from './components/page-tab-panel/page-tab-panel.component';

import { PipesModule } from "../shared/pipes/pipesModule";
import {  DxFormModule,
  DxLoadPanelModule,
  DxToolbarModule,
  DxTagBoxModule,
  DxTreeViewModule,
  DxButtonModule,
  DxBulletModule, DxCheckBoxModule,DxSwitchModule,DxDropDownBoxModule,
  DxDataGridModule,DxContextMenuModule, DxDropDownButtonModule, DxListModule,
  DxMultiViewModule, DxPopupModule, DxScrollViewModule,
  DxSelectBoxModule, DxSliderModule, DxSortableModule, DxTabPanelModule, DxTabsModule,
  DxTemplateModule, DxTooltipModule, DxLookupModule,DxColorBoxModule, DxRadioGroupModule, DxTextAreaModule ,DxTextBoxModule,DxPopoverModule } from 'devextreme-angular';
// import { PersonalizationComponent } from './components/personalization/personalization.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { NgbCarouselModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { MiPerfilComponent } from './components/mi-perfil/mi-perfil.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LyButtonModule } from '@alyle/ui/button';
import { LyToolbarModule } from '@alyle/ui/toolbar';
import { LyImageCropperModule } from '@alyle/ui/image-cropper';
import { LyExpansionIconModule } from '@alyle/ui';
import { LySliderModule } from '@alyle/ui/slider';
import { LoginComponent } from './components/login/login.component';
import { RememberUserComponent } from './components/remember-user/remember-user.component';

import { CompanySettingsListComponent } from './components/core/companySettings/company-settings-list/company-settings-list.component';
import { CompanySettingsComponent } from './components/core/companySettings/company-settings/company-settings.component';
import { ApplicationListComponent } from './components/microapplication/application-list/application-list.component';
import { MicroapplicationSettingsComponent } from './components/microapplication/microapplication-settings/microapplication-settings.component';
import { WidgetConfigComponent } from './components/components/widget-config/widget-config.component';
import { WidgetVisualizerComponent } from './components/components/widget-visualizer/widget-visualizer.component';
import { GoogleChartsModule } from 'angular-google-charts';
import { widgetpreviewcomponent } from './components/components/widget-preview/widget-preview';
import { QRCodeModule } from 'angularx-qrcode';
import { chatiacomponent } from './components/Chaia/chatia.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
@NgModule({
  declarations: [    chatiacomponent, MicroapplicationSettingsComponent,widgetpreviewcomponent,ApplicationListComponent,CompanySettingsComponent,  CompanySettingsListComponent, WidgetConfigComponent,WidgetVisualizerComponent, DashboardComponent, LoginComponent,RememberUserComponent, TestComponent, PagesComponent, PageTabPanelComponent, MiPerfilComponent],
  exports: [chatiacomponent,DashboardComponent, TestComponent, PagesComponent],
  imports: [
    BrowserAnimationsModule,
    LyButtonModule,
    LyToolbarModule,
    DragDropModule,
    LyImageCropperModule,
    LyExpansionIconModule,
    LySliderModule,
    CommonModule, 
    FormsModule,
    ReactiveFormsModule,
    DxPopoverModule ,
    DxTreeViewModule,
    LayoutModule, 
    DxColorBoxModule,
    PagesRoutes,
    DxTagBoxModule,
    ServiceModule,
    // NgxSpinnerModule,     
    DxSortableModule, 
    DxTextBoxModule,
    DxTextAreaModule,
    DxTabPanelModule,
    DxDropDownButtonModule,
    DxTemplateModule,
    DxSwitchModule,
    DxBulletModule,
    DxRadioGroupModule,
    DxDataGridModule,
    DxSelectBoxModule,    
    DxSliderModule,
    DxPopupModule,
    DxTabsModule,
    DxListModule,
    DxMultiViewModule,
    DxScrollViewModule,
    DxDropDownBoxModule,
    DxContextMenuModule,
    DxTooltipModule,
    DxCheckBoxModule,
    NgbCarouselModule,
    DxFormModule,
    DxLoadPanelModule,
    DxToolbarModule,
    DxDataGridModule,
    DxButtonModule,
    DxLookupModule,
    NgbModule,
    PipesModule,
    QRCodeModule,
    // SocialLoginModule,
    GoogleChartsModule,
    TooltipModule.forRoot()
  ],
  providers: [ 

  ]
})
export class PagesModule {}
